interface DocumentSearchFiltersProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  onSearch: () => void;
  onUpload: () => void;
  totalCount?: number;
}

export default function DocumentSearchFilters({
  searchQuery,
  onSearchChange,
  onSearch,
  onUpload,
  totalCount,
}: DocumentSearchFiltersProps) {
  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex items-center gap-4 flex-1">
        <div className="flex items-center gap-2">
          <input
            type="text"
            placeholder="제목 검색"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-[400px] h-[40px] px-4 bg-white border border-solid border-zinc-300 rounded-md focus:outline-none focus:border-black"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onSearch();
              }
            }}
          />
          <button
            onClick={onSearch}
            className="whitespace-nowrap rounded bg-black px-4 h-[40px] text-sm font-medium text-white transition-colors hover:bg-gray-800"
          >
            검색
          </button>
        </div>
        {totalCount !== undefined && totalCount > 0 && (
          <span className="text-sm text-gray-600">
            총 {totalCount.toLocaleString()}개
          </span>
        )}
      </div>

      <button
        onClick={onUpload}
        className="whitespace-nowrap rounded bg-black px-4 h-[40px] text-sm font-medium text-white transition-colors hover:bg-gray-800"
      >
        + 문서 업로드
      </button>
    </div>
  );
}